import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import Checkbox from "./elements/Checkbox"
import Swatch from "./elements/Swatch"
import Icon from "./elements/Icon"
import { sortSize } from "../helpers";

export default function Facet({ facet }) {
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet);

    let facetData = facet.data;

    if (facet.name.toLowerCase() == 'size') {
        facetData = sortSize(facetData);
    }

    return (
        <li class={`ns-sidebar-dropdown ${active ? "ns-active" : ""}`}>
            <a
                class="ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated ns-p-4"
                href="javascript:void(0)"
                tabindex="0"
                role="button"
                aria-expanded={`${ active ? true : false }`}
                data-nosto-element="facet"
                onClick={toggleActive}
            >
                <span class="ns-color-black ns-font-4 ns-font-uppercase">{facet.name}</span>
                {selectedFiltersCount > 0 && (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-color-white ns-background-primary ns-ml-1">
                        ({selectedFiltersCount})
                    </span>
                )}
                <Icon name="arrow" className="ns-absolute" />
            </a>
            <div class="ns-sidebar-submenu ns-d-none ns-p-4">
                <ul className={`ns-list-unstyled ns-p-0 ns-m-0 ns-facet-${facet.name.toLowerCase()}`}>
                    {facetData?.map(value => (
                        <li
                            class="ns-d-flex ns-justify-content-between ns-align-items-center ns-font-3"
                            data-nosto-element="facet-setting"
                        >
                            {facet.name.toLowerCase() === 'color' ? (
                                <Swatch
                                    value={value.value}
                                    selected={value.selected}
                                    className={value.selected ? 'ns-font-bold ns-font-7' : 'ns-font-7'}
                                    onChange={e => {
                                        e.preventDefault()
                                        toggleProductFilter(facet.field, value.value, !value.selected)
                                    }}
                                />
                            ) : (
                                <Checkbox
                                    value={value.value}
                                    selected={value.selected}
                                    className={value.selected ? 'ns-font-bold ns-font-7' : 'ns-font-7'}
                                    onChange={e => {
                                        e.preventDefault()
                                        toggleProductFilter(facet.field, value.value, !value.selected)
                                    }}
                                />
                            )}
                            {/* <span class="ns-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-1 ns-font-3 ns-font-bold ns-color-black ns-background-grey-light ns-border-radius-3">
                                {value.count}
                            </span> */}
                        </li>
                    ))}
                </ul>
            </div>
        </li>
    )
}
